import React, { ComponentType } from 'react';
import { OptimizelyProvider } from '@optimizely/react-sdk';
import { createOptimizelyClient, OptimizelyClientProps } from 'app/lib/optimizely';
import { isClient } from 'app/lib/utils';

export const withOptimizely: <P>(
  Component: ComponentType<P>
) => (props: P & { optimizely?: OptimizelyClientProps }) => JSX.Element = (Component) => (props) => {
  const { optimizely } = props;

  const optimizelyClient = createOptimizelyClient(optimizely || {});

  return (
    <OptimizelyProvider isServerSide={!isClient()} optimizely={optimizelyClient}>
      <Component {...props} />
    </OptimizelyProvider>
  );
};
